import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-file-excel-fill",
  "use": "rt-portal-file-excel-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-file-excel-fill\">\r\n<path d=\"M854.6,288.7c6,6,9.4,14.1,9.4,22.6V928c0,17.7-14.3,32-32,32H192c-17.7,0-32-14.3-32-32V96c0-17.7,14.3-32,32-32h424.7\r\n\tc8.5,0,16.7,3.4,22.7,9.4L854.6,288.7L854.6,288.7z M790.2,326L602,137.8V326H790.2z M575.3,477.8l-61.2,102.3l-61.8-102.4\r\n\tc-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3,0-4.5,0.6-6.4,1.9c-5.6,3.5-7.3,10.9-3.7,16.6l82.3,130.4l-83.4,132.8\r\n\tc-1.2,1.9-1.8,4.1-1.8,6.4c0,6.6,5.4,12,12,12h34.5c4.2,0,8-2.2,10.2-5.7l62.7-101.5l62.3,101.4c2.2,3.6,6.1,5.7,10.2,5.7h37.5\r\n\tc2.3,0,4.5-0.7,6.5-1.9c5.6-3.6,7.2-11,3.6-16.6L546.1,623l85.3-132.5c1.2-1.9,1.9-4.2,1.9-6.5c0-6.6-5.4-12-12-12h-35.7\r\n\tC581.4,472,577.5,474.2,575.3,477.8L575.3,477.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/file-excel-fill.svg
// module id = 1845
// module chunks = 137